import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useState } from 'react';
import { defineMessages, useIntl } from 'react-intl';
import OkCancelModal from '@/shared/components/OkCancelModal';
import api from '@/shared/api';
import handleHttpError from '@/shared/services/HandleHttpError';
const messages = defineMessages({
    VerifyDomain: {
        id: 'VerifyDomain',
        defaultMessage: 'VerifyDomain',
    },
    Domain: {
        id: 'Domain',
        defaultMessage: 'Domain',
    },
    VerifyingDomainInfo: {
        id: 'VerifyingDomainInfo',
        defaultMessage: 'Verifying the domain is needed in order for e-mails that are sent from {companyEmail} via AdminPulse to be authenticated. If the domain is not authenticated within AdminPulse, e-mails might end up in the spam folder.',
    },
    IfDomainNotCorrect: {
        id: 'IfDomainNotCorrect',
        defaultMessage: "If the domain listed below is not the domain you want to verify, please change the emailaddress under menu item 'Own Company'",
    },
    InOrderToVerify: {
        id: 'InOrderToVerify',
        defaultMessage: 'In order to verify a domain, you will need:',
    },
    NeedDomainName: {
        id: 'NeedDomainName',
        defaultMessage: 'A domain name such as myoffice.be, e-mail providers like Gmail will not work.',
    },
    NeedCnameAccess: {
        id: 'NeedCnameAccess',
        defaultMessage: 'Access to the CNAME records of this domain, your IT provider will probably be able to help you with this.',
    },
});
const AddEmailDomainModal = ({ show, onClose, onSave, suggestedEmailDomain, companyId, companyEmail, }) => {
    const intl = useIntl();
    const [domain, setDomain] = useState(suggestedEmailDomain || '');
    const [saving, setSaving] = useState(false);
    const handleSave = async () => {
        if (!domain)
            return;
        setSaving(true);
        try {
            const response = await api.base.post('/api/settings/CreateEmailDomain', {
                companyId,
                domain,
            });
            onSave(response.data);
        }
        catch (error) {
            handleHttpError(intl)(error);
        }
        finally {
            setSaving(false);
        }
    };
    return (_jsxs(OkCancelModal, Object.assign({ title: intl.formatMessage(messages.VerifyDomain), show: show, onClose: onClose, onSave: handleSave, disabled: saving || !domain, disableFullScreen: true }, { children: [_jsxs("div", Object.assign({ className: "alert alert-info" }, { children: [_jsx("div", { children: intl.formatMessage(messages.VerifyingDomainInfo, { companyEmail }) }), _jsx("div", { children: intl.formatMessage(messages.IfDomainNotCorrect) }), _jsxs("div", { children: [_jsx("div", Object.assign({ className: "margin10T" }, { children: intl.formatMessage(messages.InOrderToVerify) })), _jsxs("ul", Object.assign({ style: { paddingLeft: 18 } }, { children: [_jsx("li", { children: intl.formatMessage(messages.NeedDomainName) }), _jsx("li", { children: intl.formatMessage(messages.NeedCnameAccess) })] }))] })] })), _jsx("div", Object.assign({ className: "form-horizontal", role: "form" }, { children: _jsxs("div", Object.assign({ className: "form-group" }, { children: [_jsx("label", Object.assign({ htmlFor: "domain", className: "col-sm-4 control-label" }, { children: intl.formatMessage(messages.Domain) })), _jsx("div", Object.assign({ className: "col-sm-8" }, { children: _jsx("input", { type: "text", id: "domain", name: "domain", className: "form-control", value: domain, onChange: e => setDomain(e.target.value), placeholder: intl.formatMessage(messages.Domain), required: true }) }))] })) }))] })));
};
export default AddEmailDomainModal;
